import moment from 'moment';

export const getArrivalDateLimits = ({
  etd,
  inceptionDate,
  terminationDate,
}: {
  etd?: moment.Moment;
  terminationDate?: moment.Moment;
  inceptionDate?: moment.Moment;
}) => ({
  min: etd ?? inceptionDate ?? undefined,
  max: terminationDate ?? undefined,
});

export const getDepartureDateLimits = ({
  etdBackdateToleranceDays,
  eta,
  terminationDate,
}: {
  etdBackdateToleranceDays?: number;
  eta?: moment.Moment;
  terminationDate?: moment.Moment;
}) => ({
  min: etdBackdateToleranceDays
    ? moment().subtract(etdBackdateToleranceDays, 'days')
    : undefined,
  max: eta ?? terminationDate ?? undefined,
});
